import React from 'react'
import { Pagination } from 'react-bootstrap'
import Page from './page'

const EightPlusPagination = ({
    totalPages,
    currentPage,
    setCurrentPage
}) => {
    const pages = Array.from({length: totalPages}, (v, i) => i+1)
    return (
        <Pagination className='justify-content-center'>
            <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} />
            {pages.map((page, key) => <Page key={key} page={page} currentPage={currentPage} onSetPage={setCurrentPage} />)}
            <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} />
        </Pagination>
    )
}

export default EightPlusPagination